"use client";

import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "../lib/utils";

type SwitchSize = "md" | "lg";

type SwitchProps = React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: SwitchSize;
};

function Switch({ className, size = "md", ...props }: SwitchProps) {
  const sizeClasses: Record<
    SwitchSize,
    { root: string; thumb: string; thumbChecked: string }
  > = {
    md: {
      root: "h-4.5 w-8",
      thumb: "size-4",
      thumbChecked: "data-[state=checked]:translate-x-3.5",
    },
    lg: {
      root: "h-6 w-11",
      thumb: "size-5",
      thumbChecked: "data-[state=checked]:translate-x-5.5",
    },
  };

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        sizeClasses[size].root,
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block rounded-full ring-0 transition-transform data-[state=unchecked]:translate-x-0",
          sizeClasses[size].thumb,
          sizeClasses[size].thumbChecked
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
